<template>
  <div class="container">
    <div class="nav">
      <div
        class="navItem"
        :class="tabState === 1 ? 'action' : null"
        @click="handlerTab(1)"
      >
        回收数据列表
      </div>
      <div
        class="navItem"
        :class="tabState === 2 ? 'action' : null"
        @click="handlerTab(2)"
      >
        回收列表管理
      </div>
    </div>

    <el-form
      :inline="true"
      :model="params"
      class="demo-form-inline"
      v-show="tabState === 1"
    >
      <el-form-item label="地址">
        <el-select
          v-model="params2.address"
          @change="addressChange"
          placeholder="请选择地址"
        >
          <el-option
            v-for="item in addressList"
            :key="item.id"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            unlink-panels
            :clearable="false"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="bedata"
            @change="timechange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="queryList">查询</el-button>
        <el-button type="danger" @click="clearParams">清除查询条件</el-button>
        <el-button type="primary" @click="exportStreet">导出</el-button>
      </el-form-item>
    </el-form>
    <div class="totalAmount" v-show="tabState === 1">
      <div class="statistics">
        <div>
          <p>{{ order.zhiWeight || "--" }}</p>
          <p>纸</p>
        </div>
      </div>
      <div class="statistics">
        <div>
          <p>{{ order.shuipingWeight || "--" }}</p>
          <p>水瓶</p>
        </div>
      </div>
      <div class="statistics">
        <div>
          <p>{{ order.zasuliaoWeight || "--" }}</p>
          <p>杂塑料</p>
        </div>
      </div>
      <div class="statistics">
        <div>
          <p>{{ order.suliaokuangWeight || "--" }}</p>
          <p>塑料筐</p>
        </div>
      </div>
      <div class="statistics">
        <div>
          <p>{{ order.zasuobuWeight || "--" }}</p>
          <p>塑料布</p>
        </div>
      </div>
      <div class="statistics">
        <div>
          <p>{{ order.tieWeight || "--" }}</p>
          <p>铁</p>
        </div>
      </div>
      <div class="statistics">
        <div>
          <p>{{ order.lvWeight || "--" }}</p>
          <p>铝(kg)</p>
        </div>
      </div>
      <div class="statistics">
        <div>
          <p>{{ order.lvGeWeight || "--" }}</p>
          <p>铝(个数)</p>
        </div>
      </div>
      <div class="statistics">
        <div>
          <p>{{ order.paomoWeight || "--" }}</p>
          <p>泡沫</p>
        </div>
      </div>
      <div class="statistics">
        <div>
          <p>{{ order.zhiwuWeight || "--" }}</p>
          <p>织物</p>
        </div>
      </div>
      <div class="statistics">
        <div>
          <p>{{ order.boliWeight || "--" }}</p>
          <p>玻璃</p>
        </div>
      </div>
      <div class="statistics">
        <div>
          <p>{{ order.price || "--" }}</p>
          <p>总金额</p>
        </div>
      </div>
    </div>
    <!-- <el-table
      :data="orderList"
      style="width: 100%"
      border
      v-loading="loading"
      v-show="tabState === 3"
    >
      <el-table-column prop="boliWeight" label="玻璃(kg)"> </el-table-column>
      <el-table-column prop="lvGeWeight" label="铝(个数)"> </el-table-column>
      <el-table-column prop="lvWeight" label="铝(kg)"> </el-table-column>
      <el-table-column prop="paomoWeight" label="泡沫(kg)"> </el-table-column>
      <el-table-column prop="shuipingWeight" label="水瓶(kg)">
      </el-table-column>
      <el-table-column prop="suliaokuangWeight" label="塑料框(kg)">
      </el-table-column>
      <el-table-column prop="tieWeight" label="铁(kg)"> </el-table-column>
      <el-table-column prop="zasuliaoWeight" label="杂塑料(kg)">
      </el-table-column>
      <el-table-column prop="zasuobuWeight" label="塑料布(kg)">
      </el-table-column>
      <el-table-column prop="zhiWeight" label="纸(kg)"> </el-table-column>
      <el-table-column prop="zhiwuWeight" label="织物(kg)"> </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180px">
      </el-table-column>
      <el-table-column prop="price" label="总金额(元)"> </el-table-column>
    </el-table> -->

    <el-table
      :data="infoList"
      style="width: 100%"
      border
      v-loading="loading"
      v-show="tabState === 1"
    >
      <el-table-column prop="zhiWeight" label="纸(kg)"> </el-table-column>
      <el-table-column prop="shuipingWeight" label="水瓶(kg)"></el-table-column>
      <el-table-column
        prop="zasuliaoWeight"
        label="杂塑料(kg)"
      ></el-table-column>
      <el-table-column
        prop="suliaokuangWeight"
        label="塑料框(kg)"
      ></el-table-column>
      <el-table-column
        prop="zasuobuWeight"
        label="塑料布(kg)"
      ></el-table-column>
      <el-table-column prop="tieWeight" label="铁(kg)"> </el-table-column>
      <el-table-column prop="lvWeight" label="铝(kg)"> </el-table-column>
      <el-table-column prop="lvGeWeight" label="铝(个数)"> </el-table-column>
      <el-table-column prop="paomoWeight" label="泡沫(kg)"> </el-table-column>
      <el-table-column prop="zhiwuWeight" label="织物(kg)"> </el-table-column>
      <el-table-column prop="boliWeight" label="玻璃(kg)"> </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180px">
      </el-table-column>
      <el-table-column prop="price" label="总金额(元)"> </el-table-column>
    </el-table>
    <div class="pagination" v-show="tabState === 1">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="this.params2.pageNo"
        :page-sizes="[10, 15, 20, 25]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-button
      v-show="tabState === 2"
      type="primary"
      @click="changeDialogState"
      style="margin-bottom: 15px"
      >添加回收物品</el-button
    >
    <el-table
      v-show="tabState === 2"
      border
      :data="originData"
      style="width: 100%"
      stripe
    >
      <el-table-column prop="price" label="价格"> </el-table-column>
      <el-table-column prop="title" label="名称"> </el-table-column>
    </el-table>

    <el-dialog title="添加回收项" :visible.sync="dialogState" width="30%">
      <el-form :model="params" label-width="40px">
        <el-form-item label="价格">
          <el-input v-model="params.price"></el-input>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="params.title"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addRecovery">确 定</el-button>
        <el-button @click="dialogState = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRecoveryList,
  addRecovery,
  wlRecoveryInfoList,
  wlAddressList,
  orderSum,
} from "@/api/management";
import { getLast7Days } from "@/utils/util";
import { publicMixin } from "@/mixins/publicMixin";
export default {
  name: "walimanage",
  mixins: [publicMixin],
  data() {
    return {
      originData: [],
      params: {
        price: "",
        title: "",
      },
      dialogState: false,
      tabState: 1,
      params2: {
        pageNo: 1,
        pageSize: 10,
        createTime: "",
        endTime: "",
        address: "",
      },
      addressList: [],
      bedata: "",
      infoList: [],
      total: 0,
      loading: false,
      order: {},
    };
  },
  methods: {
    exportStreet() {
      let exportXlsUrl = "wlRecovery/wlRecoveryInfo/export";
      let fileName = "回收数据导出";
      let obj = {};
      obj = JSON.parse(JSON.stringify(this.params2));
      obj.pageNo = "1";
      obj.pageSize = "99999";
      this.export(exportXlsUrl, obj, fileName);
    },
    clearParams() {
      this.params2 = {
        pageNo: 1,
        pageSize: 10,
        createTime: "",
        endTime: "",
        address: "全部",
      };
      this.bedata = "";
      this.queryList();
    },
    handleSizeChange(val) {
      this.params2.pageSize = val;
      this.getInfoList();
    },
    handleCurrentChange(val) {
      this.params2.pageNo = val;
      this.getInfoList();
    },
    queryList() {
      this.getInfoList();
      this.getOrderSum();
    },
    timechange(val) {
      this.params2.createTime = val[0];
      this.params2.endTime = val[1];
      this.getInfoList();
    },
    handlerTab(t) {
      this.tabState = t;
      this.params2.pageNo = 1;
      this.params2.pageSize = 10;
      this.params2.address = "";
      this.params = {
        price: "",
        title: "",
      };
    },
    addressChange(e) {
      this.params2.address = e;
      this.params2.pageNo = 1;
    },
    async addRecovery() {
      const { price, title } = this.params;
      if (!price || !title) {
        this.$message.warning("请填写完整内容");
        return;
      }
      const result = await addRecovery(this.params);
      if (result.code === 200) {
        this.$message.success("添加成功");
        this.dialogState = false;
        this.getOriginData();
      } else {
        this.$message.error(result.msg);
      }
    },
    changeDialogState() {
      this.dialogState = true;
      this.params = {
        price: "",
        title: "",
      };
    },
    async getOriginData() {
      const result = await getRecoveryList();
      if (result.code === 200) {
        this.originData = result.data;
      }
    },
    async getAddressList() {
      const result = await wlAddressList();
      if (result.code === 200) {
        result.data.unshift({ id: 1, name: "全部" });
        this.addressList = result.data;
      }
    },
    async getInfoList() {
      this.loading = true;
      const result = await wlRecoveryInfoList({
        ...this.params2,
        address: this.params2.address === "全部" ? "" : this.params2.address,
      });
      if (result.code === 200) {
        this.infoList = result.data.records;
        this.total = result.data.total;
      }
      this.loading = false;
    },
    async getOrderSum() {
      this.loading = true;
      const result = await orderSum({
        ...this.params2,
        address: this.params2.address === "全部" ? "" : this.params2.address,
      });
      if (result.code === 200) {
        this.order = result.data || {};
      }
      this.loading = false;
    },
  },
  mounted() {
    this.getOriginData();
    this.getAddressList();
    this.bedata = getLast7Days();
    this.timechange(this.bedata);
    this.getOrderSum();
  },
};
</script>

<style scoped lang="less">
.container {
  padding: 20px;
}
/deep/.cell {
  text-align: center !important;
}
.nav {
  margin-bottom: 15px;
  display: flex;
  width: 100%;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #ccc;
  .navItem {
    margin-right: 30px;
    padding: 10px 0;
    cursor: pointer;
    margin-bottom: -1px;
  }
  .action {
    color: #409eff;
    border-bottom: 2px solid #409eff;
  }
  .navItem:hover {
    color: #409eff;
  }
}
.pagination {
  float: right;
  margin-top: 20px;
}
.totalAmount {
  display: flex;
  flex-wrap: nowrap;
  margin-bottom: 20px;
  width: 80%;
  flex-wrap: wrap;
  .statistics {
    margin-right: 15px;
    margin-top: 15px;
    font-size: 14px;
    width: 10%;
    display: flex;
    justify-content: space-between;
    margin-right: 15px;
    div {
      width: 120px;
      border-radius: 12px;
      text-align: center;
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
